import React, { useState } from 'react';
import { Calculator } from '../../types';
import { CalculatorShell } from './CalculatorShell';
import { AllCalculatorsModule } from './AllCalculatorsModule';
import { exportToPDF, shareToWhatsApp } from '../../utils/exportUtils';

// Import individual calculators
import NetSalaryCalculator from './work/NetSalaryCalculator';
import ThirteenthSalaryCalculator from './work/DecimoTerceiroCalculator';
import VacationCalculator from './work/FeriasCalculator';
import TerminationCalculator from './work/RescisaoCalculator';
import FGTSCalculator from './work/FGTSCalculator';
import INSSCalculator from './work/INSSCalculator';

interface WorkModuleProps {
  calculator: Calculator;
  onBack: () => void;
  isFavorite?: boolean;
  onToggleFavorite?: () => void;
}

export const WorkModule: React.FC<WorkModuleProps> = ({
  calculator,
  onBack,
  isFavorite,
  onToggleFavorite,
}) => {
  // Rolar para o topo ao entrar na calculadora
  React.useEffect(() => {
    window.scrollTo(0, 0);
    const timeoutId = setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 50);

    return () => clearTimeout(timeoutId);
  }, [calculator.slug]);

  const [exportData, setExportData] = useState<{ title: string, results: { label: string, value: string }[] } | null>(null);

  const handleExportPDF = () => {
    if (!exportData) return;
    exportToPDF({
      title: exportData.title,
      description: `Relatório gerado em ${new Date().toLocaleDateString('pt-BR')}`,
      results: exportData.results
    });
  };

  const handleShareWhatsApp = () => {
    if (!exportData) return;
    shareToWhatsApp(exportData.title, exportData.results);
  };

  const supportedSlugs = [
    'salario-liquido',
    'decimo-terceiro',
    'ferias',
    'rescisao',
    'fgts',
    'inss'
  ];

  if (!supportedSlugs.includes(calculator.slug)) {
    return <AllCalculatorsModule calculator={calculator} onBack={onBack} />;
  }

  return (
    <CalculatorShell
      calculator={calculator}
      onBack={onBack}
      isFavorite={isFavorite}
      onToggleFavorite={onToggleFavorite}
      onExportPDF={exportData ? handleExportPDF : undefined}
      onShareWhatsApp={exportData ? handleShareWhatsApp : undefined}
    >
      {renderCalculator(calculator.slug, (data) => setExportData({ title: calculator.title, results: data }))}
    </CalculatorShell>
  );
};

function renderCalculator(slug: string, onResultChange: (data: { label: string, value: string }[]) => void) {
  switch (slug) {
    case 'salario-liquido': return <NetSalaryCalculator onResultChange={onResultChange} />;
    case 'decimo-terceiro': return <ThirteenthSalaryCalculator onResultChange={onResultChange} />;
    case 'ferias': return <VacationCalculator onResultChange={onResultChange} />;
    case 'rescisao': return <TerminationCalculator onResultChange={onResultChange} />;
    case 'fgts': return <FGTSCalculator onResultChange={onResultChange} />;
    case 'inss': return <INSSCalculator onResultChange={onResultChange} />;
    default: return null;
  }
}
